<div
  class="podcast_wrapper container"
  [id]="id"
  *ngIf="!isLoading; else loadingPodcast"
>
  <!-- Headline Hubseite -->
  <div
    class="podcast_link-box"
    [ngClass]="{ 'podcast_link-box--no-headline': !linkHeadline }"
    *ngIf="linkHeadline || link"
  >
    <h4 class="podcast_link-box-headline" *ngIf="linkHeadline">
      {{ linkHeadline.trim() }}
    </h4>
    <hdi-link
      class="podcast_link-box-link"
      *ngIf="link"
      [label]="link.label | capitalize"
      [href]="link.href!"
      [title]="link.title ?? ''"
      [hrefType]="link.hrefType!"
      [type]="LinkType.PRIMARY_ARROW"
      [target]="'_self'"
    ></hdi-link>
  </div>
  <div
    class="podcast"
    *ngFor="let podcastItem of PodcastItems; let i = index; trackBy: trackById"
    [ngClass]="{ active: isOpen[i] }"
    [id]="podcastItem.id"
    #podcastsRef
  >
    <hdi-image
      class="podcast_image"
      [src]="podcastItem.image"
      [alt]="getAltTextById(podcastItem.imageIdentifier)"
      [title]="podcastItem.imageTitle"
    ></hdi-image>
    <div
      class="podcast_title"
      (click)="toggleOpenClose(i)"
      (keydown)="toggleOpenClose(i)"
      [id]="podcastItem.key"
    >
      <span class="podcast_subtitle"> {{ podcastItem.subline }}</span>

      {{ podcastItem.headline }}
    </div>
    <hdi-button
      class="podcast_btn"
      [ngClass]="{ 'podcast_btn--open': isOpen[i] }"
      [label]="headerLabel | capitalize"
      [type]="accordion"
      [isOpen]="isOpen[i]"
      [iconName]="isOpen[i] ? 'minus' : 'plus'"
      (click)="handleClick(i)"
      (keydown)="handleClick(i)"
    >
    </hdi-button>
    <div [ngClass]="{ active: isOpen[i] }" class="podcast_content">
      <div
        class="podcast_content-text"
        *ngIf="podcastItem.content"
        [innerHTML]="podcastItem.content"
      ></div>
      <div
        class="podcast_player_wrapper"
        [innerHTML]="PodcastItems[i].safeIframe"
      ></div>
    </div>
  </div>
  <div class="podcast_more-less-wrapper">
    <hdi-button
      *ngIf="isPodcastHub"
      class="show-more-button"
      [type]="moreLessType"
      [label]="isUnrolledLabel | capitalize"
      [iconName]="isUnrolledIcon"
      (click)="showMoreLess()"
      (keydown)="showMoreLess()"
    ></hdi-button>
  </div>
</div>

<!-- Loading Placeholder -->
<ng-template #loadingPodcast>
  <div class="podcast_wrapper container">
    <div class="podcast_link-box">
      <span class="podcast_link-box-headline podcast_link-box-headline--loader">
        <ngx-skeleton-loader
          [theme]="{
            width: '100%',
            height: '100%',
            'margin-bottom': '0',
            'background-color': isSectionBg ? '#f9f9fa' : '#eff1f6',
          }"
        ></ngx-skeleton-loader>
      </span>
      <span class="podcast_link-box-link podcast_link-box-link--loader">
        <ngx-skeleton-loader
          [theme]="{
            width: '100%',
            height: '100%',
            'margin-bottom': '0',
            'background-color': isSectionBg ? '#f9f9fa' : '#eff1f6',
          }"
        ></ngx-skeleton-loader>
      </span>
    </div>
    <div
      class="podcast podcast--loader"
      *ngFor="let podcastItem of [].constructor(3)"
    >
      <ngx-skeleton-loader
        [theme]="{
          width: '100%',
          height: '100%',
          'margin-bottom': '0',
          'background-color': isSectionBg ? '#f9f9fa' : '#eff1f6',
        }"
      ></ngx-skeleton-loader>
    </div>
  </div>
</ng-template>
